import cardBodyStyle from "assets/jss/material-kit-react/components/cardBodyStyle.jsx";
import imageStyles from "assets/jss/material-kit-react/imagesStyles.jsx";

const style = {
    ...imageStyles,
    ...cardBodyStyle,
    card: {
        marginBottom: "0",
        marginTop: "0",
        height: "100%",
    },
    imgCard: {
        ...imageStyles.imgCard,
        height: "300px",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "grid",
    },
    imgCardTop: {
        maxHeight: "120px",
        ...imageStyles.imgCardTop,
    },
    expand: {
        width: "auto",
        margin: "0 auto"
    },
    cardBody: {
        backgroundColor: "#ffffff"
    },
    description: {
        backgroundColor: "#17045799",
        color: "#FFF",
        width: "100%",
        height: "100%",
        maxHeight: "300px"
    }
}

export default style;


// WEBPACK FOOTER //
// ./src/assets/jss/components/projectCardStyle.jsx